import { buildApiUrl } from '@/utils/url/build-url';
import { getConfig } from '@/utils/config/config';

export const getLauncherOrigin = (): string => {
    const launcherUrl = buildApiUrl(getConfig().apis.LauncherClient);
    return new URL(launcherUrl).origin;
};

export const getLobbyOrigin = (): string => {
    if (typeof window !== 'undefined') {
        return window.location.origin;
    }
    return new URL(getConfig().domain).origin;
};

export const getAllowedGameMessageOrigins = (): Set<string> => new Set([getLobbyOrigin(), getLauncherOrigin()]);

export const isAllowedGameMessageOrigin = (origin: string): boolean =>
    Boolean(origin) && getAllowedGameMessageOrigins().has(origin);
